import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/Core/services/auth.service";

@Component({
    selector: 'login',
    templateUrl:'./login.component.html',
    styleUrls:['./login.component.css']
})



export class LoginComponent implements OnInit {
    loginForm!: FormGroup;

    
    constructor(private fb: FormBuilder, private auth: AuthService) {
      
    }

    ngOnInit() {
        this.loginForm = this.fb.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
        });
      }
    
      onSubmit(form: FormGroup) {
        if (form.valid) {
          this.auth.signIn(form.value)
        }
      }
}